import { useUserProfile } from "@vega-api/extended/auth/hooks";
import {
  UiCapabilityKey,
  useUiCapabilities,
} from "@vega-api/extended/auth/useUiCapabilities";
import { NotificationPreferenceType } from "@vega-api/generated/types/notificationPreferenceType";
import {
  useGetUserWorkbenchNotificationPreferences,
  useUpdateUserNotificationPreference,
} from "@vega-api/generated/user-notifications-v1/user-notifications-v1";
import { NotificationPreferences } from "@vega-core/components/NotificationPreferences/NotificationPreferences";
import { m } from "@vega-core/paraglide/messages";

export const GPSettingsNotifications = () => {
  const { data: profile, isLoading: isProfileLoading } = useUserProfile();
  const { capabilities } = useUiCapabilities();
  const {
    data: preferences,
    isLoading: isPreferencesLoading,
    refetch,
  } = useGetUserWorkbenchNotificationPreferences({
    query: {
      select: ({ data }) => data,
    },
  });

  const { mutate, isPending: isUpdating } = useUpdateUserNotificationPreference(
    {
      mutation: {
        onSuccess: () => refetch(),
      },
    },
  );

  const handlePreferenceChange = async (id: string, enabled: boolean) => {
    mutate({
      data: { id, enabled },
    });
  };

  if (!profile && !isProfileLoading) {
    return null;
  }
  const GP_NOTIFICATON_LOCK_CONFIG = [
    {
      type: NotificationPreferenceType.CAPITAL_ACTIVITY,
      message: m.settings_capitalActivity_tooltip(),
    },
    ...(capabilities[UiCapabilityKey.CanAccessGeneralFundMaterials]
      ? []
      : [
          {
            type: NotificationPreferenceType.GENERAL_FUND_MATERIALS,
            message: m.settings_generalFundMaterials_tooltip(),
          },
        ]),
  ];

  return (
    <NotificationPreferences
      isLoading={isProfileLoading || isPreferencesLoading}
      isUpdating={isUpdating}
      lockConfig={GP_NOTIFICATON_LOCK_CONFIG}
      onPreferenceChange={handlePreferenceChange}
      preferences={preferences}
    />
  );
};
